import React from 'react';

const Minnesota = () => {
  return (
    <div>
      <h2 className="text-xl font-bold uppercase mt-8 mb-2 border-b pb-1">
        Minnesota Specific Terms
      </h2>
      <ol className="text-black mb-4 text-base list-decimal list-inside">
        <li>Mandatory disclosure of defects required..</li>
        <li>
          Well Disclosure Certificate: Required if the property has a well.
        </li>
        <li>Radon Disclosure: Required in residential transactions.</li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2015/09/sellers-disclosure-of-lead-paint.pdf',
                '_blank'
              );
            }}
          >
            Lead-Based Paint Disclosure{' '}
          </span>{' '}
          – Only for residences that were built before 1978. This information
          should be available at the County’s Revenue Office.
        </li>
        <li>
          <span
            className="underline text-blue-500 hover:text-blue-700 cursor-pointer"
            onClick={() => {
              window.open(
                'https://eforms.com/images/2018/07/Minnesota-Sellers-Property-Disclosure-Statement.pdf',
                '_blank'
              );
            }}
          >
            Seller's Property Disclosure Statement{' '}
          </span>{' '}
          – Known as 'Real Property Form No. 15,' this form outlines any
          problems with the property and must be given to the buyer.
        </li>
      </ol>
    </div>
  );
};

export default Minnesota;
